/**
 * Shared summary-tile row for the two drift pages (Billing Drift and Pay As You Go Drift).
 *
 * Both pages render their top section through this file so the tiles, their spacing and the
 * money formatting cannot drift apart from each other.
 */

export const usd = (value) =>
  `$${Number(value || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const summaryCard = (label, value, alertClass) => (
  <div className="col-md-3 col-sm-6" key={label}>
    <div className={`alert ${alertClass}`} style={{ borderRadius: 6, padding: "14px 16px", marginBottom: 0 }}>
      <h4 style={{ marginBottom: 4, fontSize: 12, letterSpacing: 0.4 }}>{label}</h4>
      <p style={{ fontSize: 22, fontWeight: 600, margin: 0 }}>{value}</p>
    </div>
  </div>
);

/**
 * @param {{ items: Array<{ label: string, value: string, tone: string }> }} props
 *   `tone` is a Bootstrap alert class, e.g. "alert-danger".
 */
export const DriftSummaryCards = ({ items }) => (
  <div className="row" style={{ marginBottom: 18 }}>
    {items.map((item) => summaryCard(item.label, item.value, item.tone))}
  </div>
);

export default DriftSummaryCards;
